import { Coordinate, Polygon } from "@nova/protobuf"

export const convertPerimeterPolygonsToNumberArray = (polygons: Polygon[]) =>
    polygons.map((polygon) => ({
        coords: polygon.coordinates.map(({ longitude, latitude }) => [longitude, latitude]),
        width: 0,
        color: "FF1A1AE5",
    })) as { coords: [number, number][]; width?: number }[]

export const coordToLngLat = (coord: Coordinate) => [coord.longitude, coord.latitude]
